import { render, staticRenderFns } from "./ProfessionDescriptionEdit.vue?vue&type=template&id=40fa5cbf&"
import script from "./ProfessionDescriptionEdit.vue?vue&type=script&lang=js&"
export * from "./ProfessionDescriptionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports